import { Grid, makeStyles } from "@material-ui/core";
import { Typography } from "@mui/material";
import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { ReactComponent as DeleteVisitIcon } from "../../../src/assets/DeleteVisit.svg";
import DialogBox from "../../components/DialogBoxComponent/DialogBox";
import Toast from "../../components/ToastContainer/CustomToast";
import { deleteHealthQuestionarie } from "../../slices/HealthQuestionaries/HealthQuestionariesSlice";
import { ThemeContext } from "../../theme/ThemeContext";
import { ReactComponent as DeleteIcon } from "../../assets/DeleteIcon.svg";

const useStyles = makeStyles((theme) => ({
  dialogbox: {
    "& .MuiDialog-paper": {
      // minWidth: '110vh',
      maxWidth: "600px",
      // marginLeft: "250px",
      borderRadius: "20px",
      backgroundColor: (props) => (props.darkMode ? "#0E2A41" : "#fff"),
    },
  },
}));

export default function DeleteHealthQuestionaries(props) {
  const { open, handleClose } = props;
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { darkMode } = useContext(ThemeContext);
  const classes = useStyles({ darkMode });
  const [payload, setPayload] = React.useState({
    id: props.DeleteId,
    question: props?.checklitItem?.question,
  });

  const handleSubmit = () => {
    dispatch(deleteHealthQuestionarie(payload))
      .unwrap()
      .then((data) => {
        if (data.code === "CVAI0057") {
          Toast(data.message, "success");
          handleClose(false);
        } else {
          Toast(data.message, "error");
          handleClose(false);
        }
      })
      .catch((er) => {});
  };

  return (
    <>
      <DialogBox
        Header={
          <span style={{ fontSize: "21px", color: darkMode ? "#fff" : "" }}>
            {t("COMMON004")}
          </span>
        }
        className={classes.dialogbox}
        acceptText={t("confirmVisitorButton")}
        cancelText={t("COMMON008")}
        fullWidth={true}
        onClose={() => handleClose(false)}
        cancel={handleClose}
        onSubmit={handleSubmit}
        open={open}
      >
        <Grid
          container
          justifyContent="center"
          direction="column"
          alignItems={"center"}
          style={{
            backgroundColor: darkMode ? "#0E2A41" : "",
          }}
        >
          <Grid>
            <DeleteIcon width="60px" height={"50px"} />
          </Grid>
          <Grid>
            <Grid
              style={{
                wordWrap: "break-word",
                opacity: 1,
                textAlign: "center",
                display: "flex",
                flexDirection: "row",
                fontSize: "17px",
                marginTop: "15px",
              }}
            >
              <Typography
                style={{
                  color: darkMode ? "#fff" : "#242424",
                  marginRight: "4px",
                  fontSize: "17px",
                }}
              >
                {t("COMMON018")}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </DialogBox>
    </>
  );
}
